import { Box } from '@mui/material';
import { ArrowForwardRounded } from '@mui/icons-material';

import { FORTA_BLUE } from '../../../../../../../utils/colors';
import StatusIcon from '../statusIcon';

import type { ReactNode } from 'react';
import type { StatusIconVariant } from '../statusIcon';

interface StatusTransitionIconProps {
  currentIsActive: boolean;
  originalIsActive?: boolean;
  size?: number;
  variant?: StatusIconVariant;
  tooltip?: ReactNode;
}

const StatusTransitionIcon = ({
  currentIsActive,
  originalIsActive,
  size = 32,
  variant = 'rounded',
  tooltip,
}: StatusTransitionIconProps) => {
  const hasChanged = originalIsActive !== undefined && originalIsActive !== currentIsActive;

  if (!hasChanged) {
    return (
      <StatusIcon isActive={currentIsActive} size={size} variant={variant} tooltip={tooltip} />
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <StatusIcon
        isActive={originalIsActive}
        size={size}
        variant={variant}
        tooltip={originalIsActive ? 'Currently active' : 'Currently inactive'}
      />
      <ArrowForwardRounded sx={{ color: FORTA_BLUE.primary, fontSize: 20 }} />
      <StatusIcon
        isActive={currentIsActive}
        size={size}
        variant={variant}
        tooltip={
          currentIsActive ? 'Will be active after signing' : 'Will be inactive after signing'
        }
      />
    </Box>
  );
};

export default StatusTransitionIcon;
